RivalIQ.apps.Analyze.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const WidgetsView = Dashboard.views.ColumnCurationView.extend({
        collectionView: Dashboard.views.ColumnWidgets.extend({
            columnBootstrapSize: 'sm'
        })
    });

    const PdfLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ColumnWidgets.extend({
            columnWidth: null
        })
    });

    curations.Base = Dashboard.models.Curation.mixin({
        widgetsView: WidgetsView,
        exportWidgetsView: PdfLayout,
        getExportWidth: _.constant(1200),
        getUsePdfPostMargin: _.constant(true)
    });

});
